import { render, staticRenderFns } from "./PathLevel.vue?vue&type=template&id=2151eb15&scoped=true&"
import script from "./PathLevel.vue?vue&type=script&lang=js&"
export * from "./PathLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2151eb15",
  null
  
)

export default component.exports